import ActionsSet from 'core/actions/ActionsSet'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ListAction from 'core/actions/ListAction'
import ApiClient from 'api-client/ApiClient'
import { ensureArray } from 'utils/fp'

const { hagrid } = ApiClient.getInstance()

export const ssoAttributesActions = ActionsSet.make<DataKeys.SsoAttributes>({
  uniqueIdentifier: 'domain_name',
  entityName: entityNamesByKey.SsoAttributes,
  cacheKey: DataKeys.SsoAttributes,
})

export const listSsoAttributes = ssoAttributesActions.add(
  new ListAction<DataKeys.SsoAttributes, {}>(async () => {
    const response = await hagrid.getSsoAttributes()
    return ensureArray(response)
  }),
)
